// ✅ src/components/Header.js
import React from 'react';

function Header({ role }) {
  const getRoleLabel = () => {
    if (role === 'student') return '학생';
    if (role === 'instructor') return '강사';
    if (role === 'admin') return '관리자';
    return '';
  };

  return (
    <header style={{
      backgroundColor: '#00704A',
      color: 'white',
      padding: '14px 24px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)'
    }}>
      <h1 style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>📐 수학의진수학원</h1>
      <span style={{ fontSize: '0.95rem', opacity: 0.9 }}>
        {getRoleLabel()} 로그인 중
      </span>
    </header>
  );
}

export default Header;
